import axios from "../../axios";

const header = (token) => {
  return {
    headers: {
        Authorization: "Bearer "+ token
    }
  }
}

export default {
  async fetchNotifications(token, tenantName = '') {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/feature-notification';
    try {
      return await axios.get('', {
        params: { tenantName },
        ...header(token)
      });
    } catch (Exception) {
      throw Exception;
    }
  },
  async createNotification(token, payload, tenantName = '') {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/feature-notification';
    try {
      return await axios.post('', { ...payload, tenantName }, header(token));
    } catch (Exception) {
      throw Exception;
    }
  },
  async updateNotification(token, id, payload, tenantName = '') {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + `/api/feature-notification/${id}`;
    try {
      return await axios.put('', { ...payload, tenantName }, header(token));
    } catch (Exception) {
      throw Exception;
    }
  }
}
